import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true, // Mark as a standalone component
  imports: [RouterModule], // Import RouterModule to use router-outlet
  template: `<router-outlet></router-outlet>`,
  styles: [],
})
export class AppComponent {
  constructor() {
    // Inject ThemeService to ensure its constructor runs on app bootstrap
    inject(ThemeService);
  }
}
